// Lücken in eckigen Klammern - „[Frist Baubeginn]“ (seit 24.10.2026).
//
// Dieselbe Erkennung wie api/_lib/luecken.js (der Browser kann api/ nicht
// laden); api/_lib/lueckenGleich.test.js hält beide Muster gleich. Warum es
// Lücken gibt und wer sie füllt, steht dort.

// 2 bis 80 Zeichen, keine Klammern und Zeilenumbrüche darin; „[…]“ zählt nicht.
const LUECKE = /\[[^[\]\n]{2,80}\]/g;

export function lueckenIn(text) {
  return Array.from(new Set(String(text || '').match(LUECKE) || []));
}

/** Die offenen Lücken einer Ersetzung bzw. Ergänzung. */
export function lueckenDerErsetzung(aenderung) {
  return aenderung?.art === 'streichen' ? [] : lueckenIn(aenderung?.neu);
}

export function lueckenDerErgaenzung(passus) {
  return lueckenIn((passus?.absaetze || []).map((a) => a?.text || '').join('\n'));
}

/** Zerlegt einen Text für die Anzeige: [{ text, luecke: true|false }]. */
export function teileMitLuecken(text) {
  const roh = String(text || '');
  const teile = [];
  let ab = 0;
  for (const treffer of roh.matchAll(LUECKE)) {
    if (treffer.index > ab) teile.push({ text: roh.slice(ab, treffer.index), luecke: false });
    teile.push({ text: treffer[0], luecke: true });
    ab = treffer.index + treffer[0].length;
  }
  if (ab < roh.length) teile.push({ text: roh.slice(ab), luecke: false });
  return teile;
}

/** „[Frist Baubeginn]“ → „Frist Baubeginn“ - die Beschriftung des Eingabefelds. */
export function lueckenName(luecke) {
  return String(luecke || '').replace(/^\[|\]$/g, '').trim();
}

/**
 * Lücken aus dem Gespräch, die im ausgehenden Vertrag stünden (seit 24.10.2026):
 * aus zugestimmten Ersetzungen und freigegebenen Ergänzungen (Klausel-HTML).
 *
 * Ohne `html` (beim Erstellen) zählen alle - beides kommt ohnehin hinein. Mit
 * `html` (beim Bearbeiten: der Vertrag im Editor) nur, was dort noch steht; eine
 * Ergänzung, die noch nicht eingefügt ist, fügt der Server beim Abschließen ein
 * - ihre Lücken zählen deshalb ganz.
 */
export function offeneGespraechsLuecken({ ersetzungen = [], klauseln = [], html = null } = {}) {
  const mitHtml = typeof html === 'string';
  const alle = new Set();
  (ersetzungen || []).forEach((a) => lueckenDerErsetzung(a)
    .filter((l) => !mitHtml || html.includes(l))
    .forEach((l) => alle.add(l)));
  (klauseln || []).forEach((k) => {
    const eingefuegt = mitHtml && k?.id && html.includes(`data-optional-clause-id="${k.id}"`);
    lueckenIn(String(k?.content || '').replace(/<[^>]+>/g, ' '))
      .filter((l) => !eingefuegt || html.includes(l))
      .forEach((l) => alle.add(l));
  });
  return Array.from(alle);
}

export function lueckenSperrText(luecken) {
  if (!luecken?.length) return '';
  const namen = luecken.slice(0, 3).join(', ');
  return `Offene Angabe aus dem Gespräch: ${namen}${luecken.length > 3 ? ' …' : ''}. Erst in der Karte ausfüllen (Reiter Ergänzungen/Ersetzungen) – sonst steht die Lücke im Vertrag.`;
}
